import React from 'react';

import Card from '@/components/Card';

import { getGeoFromLocalStorage, prettifyCity } from '@/helpers/helpers';

import * as styles from './index.module.scss';

const MAX_RESULTS = 10;

const ResultsListings = ({ category = {}, city = '' }) => {
  const [listings, setListings] = React.useState([]);

  React.useEffect(() => {
    async function loadData() {
      setListings([]);
      try {
        const location = getGeoFromLocalStorage().zip_code
          ? `zip_code=${getGeoFromLocalStorage().zip_code}`
          : `city=${getGeoFromLocalStorage().city}&state_abbr=${getGeoFromLocalStorage().region_code}`;
        const response = await fetch(`https://twilioproxy.elocal.com/api/listings?${location}&category_id=${category.id}&limit=${MAX_RESULTS}`);
        const results = await response.json();

        // Filter out eLocal listings, any listing without a phone.
        setListings(results.listings || [])
          .filter((item) => item.display_phone && item.display_name.toLowerCase().indexOf('elocal') === -1 && !item.suppress_from_listings_page)
          .slice(0, MAX_RESULTS);
      } catch {
        (e) => console.debug(e);
      }
    }
    loadData();
  }, [category.id]);

  return listings.length > 0 ? (
    <div className={styles['results-listings-container']}>
      <div className="container">
        <h2>
          Top {category.name} in {prettifyCity(city)}
        </h2>
        <div className={styles['results-listings-cards-container']}>
          {listings.map((listing, index) => (
            <div className={styles['results-listings-card-wrapper']} key={listing.profile_id}>
              <Card result={listing} isListing category={category} index={index} />
            </div>
          ))}
        </div>
      </div>
    </div>
  ) : null;
};

export default ResultsListings;
